import { actionTypes, mutationTypes } from '@/core/constants'
import api from '@/core/apiclient'
import DownloadFile from '@/core/utils/DownloadFile'

export default {
	async [actionTypes.ATA.BUSCAR_POR_ID]({ commit }, idAta) {
		const { data } = await api.ata.buscarPorId(idAta)
		commit(mutationTypes.ATA.SET_INFORMACOES_ATA, data)
		return data
	},
	async [actionTypes.ATA.BUSCAR_POR_FILTRO]({ state }) {
		const { filtro, paginacao } = state

		const { data } = await api.ata.buscarAtasPorFiltro(filtro, paginacao)
		return data
	},
	async [actionTypes.ATA.BAIXAR_ATA_RP]({ state }, idDocumento) {
		const response = await api.ata.baixarDocumentoProcessoDigital(idDocumento)

		DownloadFile.downloadArrayBufferPdf(response.data, response.headers.filename)
	},

	async [actionTypes.ATA.BUSCAR_INFO_CABECALHO]({ state }, idAta) {
		return await api.ata.buscarInfoCabecalho(idAta)
	},

	async [actionTypes.ATA.BUSCAR_ORGAOS_PARTICIPANTES](context, idAta) {
		const { data } = await api.ata.buscarOrgaosParticipantesDaAta(idAta)
		return data
	},
}
